import { Outlet } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { ArrowUp } from 'lucide-react'
import Header from './Header'
import Footer from './Footer'

function Layout() {
  const [showScrollTop, setShowScrollTop] = useState(false)

  // Scroll durumunu izle
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 400)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  // Başa dön fonksiyonu
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      
      {/* Başa Dön Butonu */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 bg-primary-600 hover:bg-primary-700 text-white p-3 rounded-sm shadow-lg hover:shadow-xl transition-all duration-200 z-50"
          aria-label="Başa dön"
        >
          <ArrowUp size={20} />
        </button>
      )}
    </div>
  )
}

export default Layout 